import { HelpOutline } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React from 'react'

const Support = () => {
  return (
    <>
      <IconButton color="inherit">
        <HelpOutline />
      </IconButton>
    </>
  )
}

export default Support